import React, { useState, useEffect }from "react";
import { Navigate } from "react-router-dom";

import axios from "axios";
import { useSelector, useDispatch } from "react-redux";
import { loginSuccess } from "../features/authSlice";
import { BACKEND } from "../config/configEnvs";

const Login = () => {
  const [password, setPassword] = useState("");
  const [email, setEmail] = useState("");
  const [redirect, setRedirect] = useState(false);
  const [error, setError] = useState("");

  const dispatch = useDispatch();

  const user = useSelector((state) => state.auth.user);

  const handleSubmit = async (e) => {
    e.preventDefault();


    // if (isMobile) {
    //   setRedirect(true);
    //   alert("Este sitio no es accesible desde dispositivos móviles.");
    // } else {
      try {
        const response = await axios.post(
          `${BACKEND}/api/trabajadores/login`,
          {
            email: email,
            password: password,
          },
          { withCredentials: "include" }
        );
        dispatch(loginSuccess({
          user: response.data.user,
          token: response.data.token,
          exp: response.data.exp
        }));
        setRedirect(true);
      } catch (error) {
        setError("Correo o contraseña incorrectos");
      //}
    }
  };

  if (redirect) {
    return <Navigate to={"/home"} />;
  }

  if (user !== null) {
    return <Navigate to={"/home"} />;
  }

  return (
    <div className="bg-white md:bg-[#ff6400] min-h-screen flex flex-col md:flex-row">
      <div className="bg-[#ff6400] flex rounded-b-[50%] gap-4 text-white w-full py-16 md:my-auto items-center justify-center md:mx-auto md:w-1/2 md:p-4 text-center">
        <div className="md:absolute md:top-8 md:left-8">
          <img className="h-16 w-16" src="/images/logo-blanco.png" alt="" />
        </div>
        <div className="md:mx-auto flex flex-col justify-center items-center">
          <div>
            <h1 className="text-3xl md:text-4xl lg:text-5xl xl:text-6xl 2xl:text-7xl text-start text-black mx-auto font-medium">
              CONTROL DE
              <br />
              <span className="text-white font-bold text-4xl md:text-5xl lg:text-6xl xl:text-7xl 2xl:text-8xl">
                ASISTENCIA
              </span>
            </h1>
            <hr className="mt-6 h-1 bg-white w-72 items-start justify-start hidden md:flex" />
          </div>
        </div>
      </div>

      <div className="w-full mt-16 md:mt-0 md:w-1/2 bg-white md:rounded-l-full md:rounded-tr-full">
        <div className="flex justify-center items-center h-full">
          <div className="flex flex-col items-center justify-center">
            <h2 className="mb-12 font-bold text-2xl lg:text-3xl uppercase">
              Iniciar Sesión
            </h2>
            <form
              className="flex w-full max-w-sm flex-col"
              onSubmit={handleSubmit}
            >
              <label
                className="mb-2 text-gray-800 font-bold"
                htmlFor="username"
              >
                Usuario
              </label>
              <input
                className="px-4 py-2 rounded border border-gray-300 mb-4"
                type="text"
                id="username"
                name="username"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
              <label
                className="mb-2 text-gray-800 font-bold"
                htmlFor="password"
              >
                Contraseña
              </label>
              <input
                className="px-4 py-2 rounded border border-gray-300 mb-4"
                type="password"
                id="password"
                name="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
              <button
                className="bg-[#ff6400] my-8 rounded-full text-white font-bold py-2 px-4"
                type="submit"
              >
                Ingresar
              </button>
              {error && <p className="text-red-500 mt-2">{error}</p>}{" "}
              {/* Mostrar el mensaje de error si existe */}
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
